// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"db47e368","488":"1ad64378"}[chunkId] + ".chunk.js";
};